define(function (require) {
	const DetailsView = require('./v_cpv_details');
	const AddDetailsView = require('./v_cpv_add_details');
	const tpl = require('civicsViews/detail_view/templates/t_lov_detail.hbs');
	const IpsModelCollection = require('civicsBase/ipsModelCollection');
	const IpsModel = require('civicsBase/ipsModel');
	const ViewManager = require('civicsUtils/view_manager');
	return Marionette.LayoutView.extend({
		initialize: function (options) {
			this.config = options.config;
			//isAdd is ALWAYS TRUE if we are in add instrument. if we are in Instrument Details, it is always false.
			//we can use this to determine whether to allow edit/delete/add permissions in conjunction with the appropriate
			//table attributes from IPS
			this.isAdd = options.isAdd;
			this.useDetailCollection = options.useDetailCollection;
			this.toggleEnabled = options.toggleEnabled;
			this.ineffectiveApplicant = options.ineffectiveApplicant;
			this.initialEnabled = options.initialEnabled;
			this.detailTypeModelCollection = options.detailTypeModelCollection;
			this.modelDetailPropertyId = options.modelDetailPropertyId;
			this.parentIdPropertyId = options.parentIdPropertyId;
			this.model = options.model;
			this.loadParentHansenModel = options.loadParentHansenModel;
			this.defaultExpanded = options.defaultExpanded;
		},
		onShow: function () {
			var self = this;
			// if detail type collection is not provided, discover the information from the detail data
			if (!this.detailTypeModelCollection) {
				this.detailTypeModelCollection = new IpsModelCollection();
				var details = this.model.get(this.modelDetailPropertyId);
				if (details) {
					_.forEach(details.models, d => {
						var data = d.get('detailType') ? d.get('detailType').toJSON(): d.toJSON();
						var temp = new IpsModel();
						temp.set(data, { silent: true });
						temp.parentId = d.get('id');

						if (!data.description && data.classDescription) {
							//this is CRM and uses classDescription
							temp.set('description', data.classDescription);
						}

						var display = temp.get('display');
						// if display is not set or bit flag for portal is set
						if (_.isNull(display) || _.parseInt(display) === 2) {
							this.detailTypeModelCollection.add(temp, { silent: true });
						}
					});
				}
				else {
					if (__DEV__) console.log('A valid modelDetailProperty or detailTypeModelCollection is required.');
				}
			}
			else {
				// remove anything is not displayed in portal
				var noShows = [];
				_.forEach(this.detailTypeModelCollection.models, t => {
					t.parentId = null;
					if (self.model && self.parentIdPropertyId) {
						t.parentId = self.model.get(self.parentIdPropertyId);
					}
					if (!t.get('description') && t.get('classDescription')) {
						//this is CRM and uses classDescription
						t.set('description', t.get('classDescription'));
					}
					var display = t.get('display');
					if (_.isNull(display) || _.parseInt(display) != 2) {
						noShows.push({ id: t.get('id') });
					}

				});
				if (noShows.length > 0) {
					this.detailTypeModelCollection.remove(noShows);
				}
			}

			// call the sort method
			this.detailTypeModelCollection.sort('displayOrder');

			if (this.isAdd) {
				this.detailsRegion.show(
					new AddDetailsView({
						collection: this.detailTypeModelCollection,
						config: self.config,
						useDetailCollection: this.useDetailCollection,
						toggleEnabled: this.toggleEnabled,
						initialEnabled: this.initialEnabled,
						aggregateModel: this.model,
						aggregateModelDetailPropertyId: this.modelDetailPropertyId,
						loadParentHansenModel: this.loadParentHansenModel,
						defaultExpanded: this.defaultExpanded
					})
				);
			}
			else {
				this.detailsRegion.show(
					new DetailsView({
						collection: this.detailTypeModelCollection,
						config: this.config,
						useDetailCollection: this.useDetailCollection,
						toggleEnabled: this.toggleEnabled,
						ineffectiveApplicant: this.ineffectiveApplicant,
						initialEnabled: this.initialEnabled,
						aggregateModel: this.model,
						aggregateModelDetailPropertyId: this.modelDetailPropertyId,
						loadParentHansenModel: this.loadParentHansenModel,
						defaultExpanded: this.defaultExpanded
					})
				);
			}
		},
		//todo: for each child view, return a merged validation error
		onValidate: function () {
			this.valid = true;//set valid to true. if any validation errors encountered, will change to false
			// saveData save serialize each detail view and put the data in the 'details' property
			_.forEach(this.detailsRegion.currentView.children._views, view => {
				if (view && view.triggerMethod) {
					view.triggerMethod("validate");
				}
			});
		},
		onChildviewInvalid: function () {
			this.valid = false;
		},
		onSaveData: function (skipValidation) {
			// saveData save serialize each detail view and put the data in the 'details' property
			_.forEach(this.detailsRegion.currentView.children._views, view => {
				if (view && view.triggerMethod) {
					view.triggerMethod("saveData", this.model, this.modelDetailPropertyId, this.useDetailCollection, skipValidation);
				}
			});
		},
		template: tpl,
		regions: {
			detailsRegion: '.detail-container',
		},
		modelEvents: {
			change: 'render'
		},
		templateHelpers: function () {
			return {};
		},
		childEvents: {
			'saved': 'onDetailSaved'
		},
		onDetailSaved:function(){
			ViewManager.broadcast(this,'saved');
		}
	});
});
